import fetch_serve from "@/config/request";

// 登录
export function login(data) {
  return fetch_serve({
    url: '/api/Auth/login',
    method: 'post',
    data
  })
}

// 退出登录
export function logout() {
    return fetch_serve({
        url: '/api/Auth/logout',
        method: 'post'
    })
}

// 获取用户信息
export function getUserInfo() {
  return fetch_serve({
    url: '/user/info',
    method: 'get'
  })
}

// 获取用户列表
export function getUserList(data) {
    const params = new URLSearchParams()
    if (data.currentPage) params.append('pageIndex', data.currentPage)
    if (data.pageSize) params.append('pageSize', data.pageSize)
    if (data.keyword) params.append('searchKeyword', data.keyword)
    if (data.isActive !== '' && data.isActive !== undefined && data.isActive !== null) params.append('isActive', data.isActive)
    const query = params.toString()
    return fetch_serve({
        url: `/api/Users${query ? '?' + query : ''}`,
        method: 'get'
    })
}

// 新增用户
export function addUserInfo(data) {
    return fetch_serve({
        url: `/api/Users`,
        method: 'post',
        data
    })
}

// 修改用户
export function updateUserInfo(data) {
    return fetch_serve({
        url: `/api/Users/${data.id}`,
        method: 'put',
        data
    })
}

// 删除用户
export function deleteUser(id) {
    return fetch_serve({
        url: `/api/Users/${id}`,
        method: 'delete'
    })
}
